import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import Button from "../../components/Button";
import Icon from "../../components/Icon";
import EmailWidthPicker from "../../components/EmailWidthPicker";
import EditableLabel from "../../components/EditableLabel";
import ImageMiniPicker from "../ImageMiniPicker/ImageMiniPicker";
import {
  Toolbar,
  ToolbarGroup,
  ToolbarFlexibleSpacer,
  ToolbarSpacer,
} from "../../components/Toolbar";
import {
  toggleEditorBreakdown,
  updateEmailModule,
  toggleEditModuleHtml,
  toggleEditModuleCss,
  toggleEditModuleData,
  toggleEditModuleTemplate,
  toggleEditModulePreview,
  toggleEditModuleImagePicker,
  setEditorDisplayWidth,
  updateEditModuleNameValue,
  openModal,
} from "../../actions";

export class EditEmailModuleToolbar extends Component {
  constructor(props) {
    super(props);
    this.save = this.save.bind(this);
    this.onSelectImage = this.onSelectImage.bind(this);
    this.setPreviewWidth = this.setPreviewWidth.bind(this);
    this.onUpdateName = this.onUpdateName.bind(this);
    this.openSendModal = this.openSendModal.bind(this);
  }

  onSelectImage() {
    this.props.toggleEditModuleImagePicker();
  }

  onUpdateName(newName) {
    this.props.updateEditModuleNameValue(newName);
  }

  save() {
    const { accountId } = this.props;
    if (this.props.emailModule.id) {
      this.props.updateEmailModule(
        accountId,
        this.props.emailModule.id,
        this.props.emailModule
      );
    }
  }

  setPreviewWidth(width) {
    this.props.setEditorDisplayWidth(width);
  }

  openSendModal() {
    const { accountId, unsavedChanges, emailModule } = this.props;
    const { id } = emailModule;

    if (unsavedChanges) {
      this.props.openModal("confirm", {
        title: "Module has unsaved changes",
        description: "Save changes before sending",
        buttons: [
          {
            label: "Save",
            type: "primary",
            actionFn: {
              name: "updateEmailModule",
              arguments: [accountId, id, emailModule],
            },
          },
        ],
      });
      return;
    }

    this.props.openModal("send-email-module", {
      accountId,
      id,
    });
  }

  render() {
    const {
      emailModule,
      unsavedChanges,
      showHtml,
      showCss,
      showData,
      showTemplate,
      showPreview,
      accountId,
      showImagePicker,
      displayWidth,
    } = this.props;
    const activeStyle = {
      background: "#ddd",
    };

    return (
      <div>
        <Toolbar>
          <ToolbarGroup width="300px">
            <EditableLabel
              value={emailModule.name}
              onChange={this.onUpdateName}
              width="300px"
            />
          </ToolbarGroup>

          <ToolbarFlexibleSpacer />

          <ToolbarGroup width="800px" align="center">
            <Button
              type={showImagePicker ? "button" : "link"}
              onClick={this.props.toggleEditModuleImagePicker}
            >
              Images
            </Button>
            <Button
              type={showHtml ? "button" : "link"}
              onClick={this.props.toggleEditModuleHtml}
            >
              HTML
            </Button>
            <Button
              type={showCss ? "button" : "link"}
              onClick={this.props.toggleEditModuleCss}
            >
              CSS
            </Button>
            <Button
              type={showData ? "button" : "link"}
              onClick={this.props.toggleEditModuleData}
            >
              Data
            </Button>
            <Button
              type={showTemplate ? "button" : "link"}
              onClick={this.props.toggleEditModuleTemplate}
            >
              Template
            </Button>
            <Button
              type={showPreview ? "button" : "link"}
              onClick={this.props.toggleEditModulePreview}
            >
              Preview
            </Button>

            {showPreview && (
              <span>
                <ToolbarSpacer />
                <EmailWidthPicker
                  width={displayWidth}
                  onChange={this.setPreviewWidth}
                />
              </span>
            )}
          </ToolbarGroup>

          <ToolbarFlexibleSpacer />

          <ToolbarGroup width="300px" align="right">
            <Link to={`/clients/${accountId}/email-modules`}>
              <Button type="link">
                <Icon icon="close" title="Close" />
              </Button>
            </Link>
            <Button type="link" onClick={this.openSendModal}>
              <Icon icon="envelope" title="Send" />
            </Button>
            <Button
              color={unsavedChanges ? "primary" : "greyed"}
              disabled={!unsavedChanges}
              onClick={this.save}
            >
              Save
            </Button>
          </ToolbarGroup>
        </Toolbar>
        <ImageMiniPicker
          accountId={accountId}
          visible={showImagePicker}
          onSelect={this.onSelectImage}
        />
      </div>
    );
  }
}

EditEmailModuleToolbar.propTypes = {
  displayWidth: PropTypes.number.isRequired,
};

// Connect state data
function mapStateToProps(state) {
  const {
    emailModule,
    unsavedChanges,
    showHtml,
    showCss,
    showData,
    showTemplate,
    showPreview,
    showImagePicker,
  } = state.emailModuleEditor;
  const { displayWidth } = state.editor;

  return {
    emailModule,
    unsavedChanges,
    showHtml,
    showCss,
    showData,
    showTemplate,
    showPreview,
    showImagePicker,
    displayWidth,
  };
}

// Connect actions
export default connect(mapStateToProps, {
  toggleEditorBreakdown,
  updateEmailModule,
  toggleEditModuleHtml,
  toggleEditModuleCss,
  toggleEditModuleData,
  toggleEditModuleTemplate,
  toggleEditModulePreview,
  toggleEditModuleImagePicker,
  setEditorDisplayWidth,
  updateEditModuleNameValue,
  openModal,
})(EditEmailModuleToolbar);
